module.exports = __webpack_public_path__ + "img/scsdkwl.c6dcaae7.png";